import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';

export const CaptionWithReadMore = ({ caption }: { caption: string }) => {
  const { t } = useTranslation('common');
  const [expanded, setExpanded] = useState(false);

  if (!caption) {
    return <p className="text-sm text-gray-400">{t('no_caption', { defaultValue: 'No caption' })}</p>;
  }

  const isLong = caption.length > 120;

  return (
    <div>
      <p className={cn('text-sm text-gray-700 whitespace-pre-wrap', !expanded && isLong && 'line-clamp-3')}>
        {caption}
      </p>
      {isLong && (
        <button
          onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}
          className="text-xs text-primary-500 hover:text-primary-600 mt-1 font-medium"
        >
          {expanded ? t('show_less', { defaultValue: 'Show less' }) : t('read_more', { defaultValue: 'Read more' })}
        </button>
      )}
    </div>
  );
};
